<template>
    <form class="mb-12">
        <strong class="mb-4 block uppercase text-base">Search by</strong>
        <div class="mb-4">
            <label class="heading-font text-sm uppercase font-normal mg-color-secondary-lighter" for="Keyword">Name</label>
            <input type="text" v-model="keyword" class="mg-form-control"/>
        </div>
        <!-- <div class="mb-4">
            <taxonomy-select label="Alphabetical" taxonomy="alphabet"></taxonomy-select>
        </div> -->
        <div class="mb-4">
            <taxonomy-select label="Commodity" taxonomy="commodity"></taxonomy-select>
        </div>
        <div class="mb-4">
            <taxonomy-select label="Type" taxonomy="member_type"></taxonomy-select>
        </div>
        <div class="mb-8">
            <taxonomy-select label="Area of business" taxonomy="member_area_of_business"></taxonomy-select>
        </div>
        <button @click.prevent="reset" class="mg-button--tertiary" type="reset">Reset</button>
        <button @click.prevent="getMembers(true)">Search</button>
    </form>
</template>

<script>
import NProgress from "nprogress";
import { mapActions, mapMutations } from "vuex";
import TaxonomySelect from "./taxonomy-select";

export default {
    name: "member-filter",
    components: {
        "taxonomy-select": TaxonomySelect
    },
    computed: {
        keyword: {
            get() {
                return this.$store.state.memberFilter.search;
            },
            set(value) {
                this.$store.commit("updateMemberSearch", value);
            }
        }
    },
    methods: {
        ...mapMutations(["resetMemberFilter"]),
        ...mapActions(["getMembers"]),
        reset() {
            this.resetMemberFilter();
            this.getMembers(true);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/member-filter.vue